import type { ReactElement } from 'react';

export interface StageViewConfig {
  key: string;
  label: string;
  icon?: ReactElement;
  /** Последний год планирования, в котором представление доступно (включительно) */
  maxYear?: number;
}

/** Доступно ли представление в выбранном году планирования */
export function isStageViewAvailable(view: StageViewConfig, year: number): boolean {
  return view.maxYear === undefined || year <= view.maxYear;
}

export interface StageConfig {
  title: string;
  description: string;
  icon: ReactElement;
  path: string;
  /** Представления этапа (отображаются в sub-header как вторая строка) */
  views?: StageViewConfig[];
  /** RBAC-ресурс для проверки доступа (если отличается от родительского) */
  rbacResource?: string;
  /**
   * Section-ключ в `plng.ui_configs` (для админки UI-Config).
   * Если не задан — используется `rbacResource`. Задавайте явно только когда
   * секция в БД отличается от RBAC-ресурса (см. `Корректировка цен`).
   */
  configSection?: string;
}
